import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:65
* @route '/solutions'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/solutions',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:65
* @route '/solutions'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:65
* @route '/solutions'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:65
* @route '/solutions'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:65
* @route '/solutions'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:65
* @route '/solutions'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:65
* @route '/solutions'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\PublicController::marketing
* @see app/Http/Controllers/PublicController.php:70
* @route '/solutions/marketing'
*/
export const marketing = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: marketing.url(options),
    method: 'get',
})

marketing.definition = {
    methods: ["get","head"],
    url: '/solutions/marketing',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::marketing
* @see app/Http/Controllers/PublicController.php:70
* @route '/solutions/marketing'
*/
marketing.url = (options?: RouteQueryOptions) => {
    return marketing.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::marketing
* @see app/Http/Controllers/PublicController.php:70
* @route '/solutions/marketing'
*/
marketing.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: marketing.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::marketing
* @see app/Http/Controllers/PublicController.php:70
* @route '/solutions/marketing'
*/
marketing.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: marketing.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::marketing
* @see app/Http/Controllers/PublicController.php:70
* @route '/solutions/marketing'
*/
const marketingForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: marketing.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::marketing
* @see app/Http/Controllers/PublicController.php:70
* @route '/solutions/marketing'
*/
marketingForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: marketing.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::marketing
* @see app/Http/Controllers/PublicController.php:70
* @route '/solutions/marketing'
*/
marketingForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: marketing.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

marketing.form = marketingForm

/**
* @see \App\Http\Controllers\PublicController::sales
* @see app/Http/Controllers/PublicController.php:75
* @route '/solutions/relances-commerciales'
*/
export const sales = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sales.url(options),
    method: 'get',
})

sales.definition = {
    methods: ["get","head"],
    url: '/solutions/relances-commerciales',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::sales
* @see app/Http/Controllers/PublicController.php:75
* @route '/solutions/relances-commerciales'
*/
sales.url = (options?: RouteQueryOptions) => {
    return sales.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::sales
* @see app/Http/Controllers/PublicController.php:75
* @route '/solutions/relances-commerciales'
*/
sales.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sales.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::sales
* @see app/Http/Controllers/PublicController.php:75
* @route '/solutions/relances-commerciales'
*/
sales.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: sales.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::sales
* @see app/Http/Controllers/PublicController.php:75
* @route '/solutions/relances-commerciales'
*/
const salesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sales.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::sales
* @see app/Http/Controllers/PublicController.php:75
* @route '/solutions/relances-commerciales'
*/
salesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sales.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::sales
* @see app/Http/Controllers/PublicController.php:75
* @route '/solutions/relances-commerciales'
*/
salesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sales.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

sales.form = salesForm

/**
* @see \App\Http\Controllers\PublicController::notifications
* @see app/Http/Controllers/PublicController.php:80
* @route '/solutions/notifications'
*/
export const notifications = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: notifications.url(options),
    method: 'get',
})

notifications.definition = {
    methods: ["get","head"],
    url: '/solutions/notifications',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::notifications
* @see app/Http/Controllers/PublicController.php:80
* @route '/solutions/notifications'
*/
notifications.url = (options?: RouteQueryOptions) => {
    return notifications.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::notifications
* @see app/Http/Controllers/PublicController.php:80
* @route '/solutions/notifications'
*/
notifications.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: notifications.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::notifications
* @see app/Http/Controllers/PublicController.php:80
* @route '/solutions/notifications'
*/
notifications.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: notifications.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::notifications
* @see app/Http/Controllers/PublicController.php:80
* @route '/solutions/notifications'
*/
const notificationsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: notifications.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::notifications
* @see app/Http/Controllers/PublicController.php:80
* @route '/solutions/notifications'
*/
notificationsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: notifications.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::notifications
* @see app/Http/Controllers/PublicController.php:80
* @route '/solutions/notifications'
*/
notificationsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: notifications.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

notifications.form = notificationsForm

/**
* @see \App\Http\Controllers\PublicController::integrations
* @see app/Http/Controllers/PublicController.php:85
* @route '/solutions/integrations'
*/
export const integrations = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: integrations.url(options),
    method: 'get',
})

integrations.definition = {
    methods: ["get","head"],
    url: '/solutions/integrations',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::integrations
* @see app/Http/Controllers/PublicController.php:85
* @route '/solutions/integrations'
*/
integrations.url = (options?: RouteQueryOptions) => {
    return integrations.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::integrations
* @see app/Http/Controllers/PublicController.php:85
* @route '/solutions/integrations'
*/
integrations.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: integrations.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::integrations
* @see app/Http/Controllers/PublicController.php:85
* @route '/solutions/integrations'
*/
integrations.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: integrations.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::integrations
* @see app/Http/Controllers/PublicController.php:85
* @route '/solutions/integrations'
*/
const integrationsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: integrations.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::integrations
* @see app/Http/Controllers/PublicController.php:85
* @route '/solutions/integrations'
*/
integrationsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: integrations.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::integrations
* @see app/Http/Controllers/PublicController.php:85
* @route '/solutions/integrations'
*/
integrationsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: integrations.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

integrations.form = integrationsForm

const solutions = {
    index: Object.assign(index, index),
    marketing: Object.assign(marketing, marketing),
    sales: Object.assign(sales, sales),
    notifications: Object.assign(notifications, notifications),
    integrations: Object.assign(integrations, integrations),
}

export default solutions